import TextField from "@mui/material/TextField";
import React from "react";
import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles((theme) => ({
  root: {
    "&.MuiTextField-root": {
      marginBottom: theme.spacing(1),
      marginTop: theme.spacing(1),
    },
  },
}));

const MaterialTextField = ({
  field,
  label,
  required,
  type,
  form,
  displayInputHint,
}) => {
  const classes = useStyles();

  // As in Input: displayInputHint shows the error before the field is
  // touched, but the field is only marked as an error once it is touched
  let errorText = errorText;
  if (
    (displayInputHint || form.touched[field.name]) &&
    form.errors[field.name]
  ) {
    errorText = form.errors[field.name];
  }
  return (
    <TextField
      className={classes.root}
      density="normal"
      label={label}
      type={type}
      required={required}
      fullWidth
      error={Boolean(form.touched[field.name] && form.errors[field.name])}
      helperText={errorText}
      {...field}
    />
  );
};

export default MaterialTextField;
